import {
    CameraDetectionScreens,
    VideoAccess
} from "./camera-detection-constants";

const GetScreenName = (
    isLoading: boolean,
    hasCamera: boolean,
    videoAccess: VideoAccess
) => {
    switch (true) {
        case isLoading:
            return CameraDetectionScreens.Loading;
        case hasCamera && videoAccess === VideoAccess.NotRequested:
            return CameraDetectionScreens.RequestAccess;
        case hasCamera && videoAccess === VideoAccess.Granted:
            return CameraDetectionScreens.Success;
        case hasCamera && videoAccess === VideoAccess.Denied:
            return CameraDetectionScreens.Denied;
        case !hasCamera:
        default:
            return CameraDetectionScreens.NoCamera;
    }
};

export default GetScreenName;
